export const GEOGRAPHY_TOOLTIP_DEFAULT = 'Geographies';
export const GEOGRAPHY_TOOLTIP_SINGLE = (name: string) => `Geographies : ${name}`;
export const GEOGRAPHY_TOOLTIP_MULTIPLE = 'Geographies : Multiple Selections';
export const GEOGRAPHY_LABEL = 'Multiple Selections';